import { render, staticRenderFns } from "./edit-round-modal.vue?vue&type=template&id=5f95ff8a"
import script from "./edit-round-modal.vue?vue&type=script&lang=js"
export * from "./edit-round-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports